import axios from 'axios'
import {
	Message
} from 'element-ui'
import {
	category
} from './modules/category.js'
import {
	material
} from './modules/material.js'
import {
	product
} from './modules/product.js'
import {
	productCategory
} from './modules/product_category.js'
import {
	design
} from './modules/design.js'
import {
	order
} from './modules/order.js'
import {
	cart
} from './modules/cart.js'
import {
	address
} from './modules/address.js'
import {
	banner,
	config
} from './modules/banner.js'
import {
	splashAd
} from './modules/splash_ad.js'
import {
	expressCompany
} from './modules/express_company.js'
import {
	admin
} from './modules/admin.js'
import {
	pc
} from './modules/pc.js'
import {
	coupon
} from './modules/coupon.js'
import {
	promotion
} from './modules/promotion.js'
import {
	wallet
} from './modules/wallet.js'
import {
	homeEntry
} from './modules/home_entry.js'
const baseURL = location.host.startsWith('localhost') ? 'http://localhost:8993' : `https://${location.host}`
// 工具函数：处理图片URL
// 如果是 http: 或 https: 开头的直接返回原链接，否则在前面加 baseURL（如果链接不是以/开头，则增加/）
function siteUrl(url) {
	if (!url) return ''
	// 如果是 http: 或 https: 开头的，直接返回
	if (url.startsWith('http:') || url.startsWith('https:')) {
		return url
	}
	// 如果不是以 / 开头，增加 /
	if (!url.startsWith('/')) {
		return baseURL + '/' + url
	}
	return baseURL + url
}

// 创建axios实例
const service = axios.create({
	baseURL: `${baseURL}/api`,
	timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token')
		if (token) {
			config.headers['Authorization'] = token
		}
		return config
	},
	error => {
		console.error('请求错误:', error)
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		console.log('[API] 响应数据:', res)
		// 自动刷新 token（如果响应中有新 token）
		if (res.newToken) {
			localStorage.setItem('token', res.newToken)
			console.log('[API] Token 已自动刷新')
		}
		if (res.data && res.data.newToken) {
			localStorage.setItem('token', res.data.newToken)
			console.log('[API] Token 已自动刷新')
		}
		if (res.code !== 0 && res.code !== 200) {
			if (res.code === 401) {
				console.log('[API] 收到 401，清除登录信息')
				localStorage.removeItem('token')
				localStorage.removeItem('userInfo')
			}
		}
		return res
	},
	error => {
		console.error('[API] 响应错误:', error)
		if (error.response) {
			if (error.response.status === 401) {
				console.log('[API] 收到 401 状态码')
				Message.error('登录已过期,请重新登录')
				localStorage.removeItem('token')
				localStorage.removeItem('userInfo')
			} else if (error.response.status === 403) {
				Message.error('没有权限访问')
			} else if (error.response.status === 404) {
				Message.error('请求的资源不存在')
			} else if (error.response.status === 500) {
				Message.error('服务器内部错误')
			} else {
				Message.error((error.response.data && error.response.data.message) || '请求失败')
			}
		} else if (error.code === 'ECONNABORTED') {
			Message.error('请求超时')
		} else {
			Message.error('网络错误,请检查网络连接')
		}
		return Promise.reject(error)
	}
)

// 导出模块
export {
	category,
	material,
	product,
	productCategory,
	design,
	order,
	cart,
	address,
	banner,
	config,
	splashAd,
	expressCompany,
	admin,
	pc,
	coupon,
	promotion,
	wallet,
	homeEntry,
	service,
	siteUrl
}

// 默认导出
export default {
	category,
	material,
	product,
	productCategory,
	design,
	order,
	cart,
	address,
	banner,
	config,
	splashAd,
	expressCompany,
	admin,
	pc,
	coupon,
	promotion,
	wallet,
	homeEntry,
	service,
	siteUrl,
	// base64 图片上传
	uploadBase64: (data) => service.post('/upload/upload-base64', data)
}


// WEBPACK FOOTER //
// ./src/api/index.js